import { render, staticRenderFns } from "./ProductSliderListItem.vue?vue&type=template&id=5f058c2c"
import script from "./ProductSliderListItem.vue?vue&type=script&lang=js"
export * from "./ProductSliderListItem.vue?vue&type=script&lang=js"
import style0 from "./ProductSliderListItem.vue?vue&type=style&index=0&id=5f058c2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductListItem: require('/app/components/ProductListItem.vue').default})
